import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

/** One item per identity project: the project P0 mints agentic identities in,
 * and the connector that mints them there.
 *
 * The connector runs in the project it mints in, so its custom role binds on
 * that one project and nowhere else — the whole blast radius of the most
 * privileged thing P0 does in GCP is the project the customer chose for it.
 */
export const GcpServiceAccountComponents = InstallSpec({
  "iam-write": ItemComponent({
    label: "Agentic identities",
    description:
      "Runs P0's connector that mints a short-lived service account for each agentic session",
    // The item is identified by the project, picked from the installed gcloud
    // projects; the connector and the identities both live there.
    type: "dynamic",
    maturity: "beta",
    schema: {
      connectorServiceName: Element({
        label: "Cloud Run service name",
        description: "The Cloud Run service hosting the connector",
        type: "generated",
      }),
      connectorServiceAccount: Element({
        label: "Connector service account",
        description: "The service account the connector runs as",
        type: "generated",
      }),
      connectorServiceUri: Element({
        label: "Cloud Run service URI",
        description: "The connector's Cloud Run invocation URL",
        type: "generated",
      }),
      connectorRegion: Element({
        label: "Region",
        description: "The Google Cloud region the connector runs in",
        type: "hidden",
        step: "new",
      }),
    },
  }),
});
